// extracted by mini-css-extract-plugin
export default {"buttons":"TrapImagesViewerComponent_buttons__JAwjl"};